//Data for mapping filters in charts
export const filterOptions = [
  { label: "Day", value: "0" },
  { label: "Week", value: "1" },
  { label: "Month", value: "2" },
  { label: "Year", value: "3" },
  { label: "Custom", value: "4" },
  { label: "Lifetime", value: "5" },
];

//Constants for brand performance default dropdown
export const starRatingDefaultResponse = [
  {
    value: "",
    label: "All",
    filter: "GuestSentiments > 0 ",
    disabled: true,
    maxStar: "5.0",
    minStar: "0",
    equalsValue: "> 0",
  },
  {
    value: "1",
    label: "1 Star",
    filter: "GuestSentiments = 1",
    maxStar: "1.99",
    minStar: "0.1",
    equalsValue: "= 1",
  },
  {
    value: "2",
    label: "2 Star",
    filter: "GuestSentiments = 2",
    maxStar: "2.99",
    minStar: "2.0",
    equalsValue: "= 2",
  },
  {
    value: "3",
    label: "3 Star",
    filter: "GuestSentiments = 3",
    maxStar: "3.99",
    minStar: "3.0",
    equalsValue: "= 3",
  },
  {
    value: "4",
    label: "4 Star",
    filter: "GuestSentiments = 4",
    maxStar: "4.99",
    minStar: "4",
    equalsValue: "= 4",
  },
  {
    value: "5",
    label: "5 Star",
    filter: "GuestSentiments = 5",
    maxStar: "5",
    minStar: "5",
    equalsValue: "= 5",
  },
];

export const starRatingTransactionResponse = [
  {
    value: "",
    label: "All",
    filter: "(GuestTransaction >= 0 AND GuestTransaction <= 5.0) ",
    disabled: true,
    maxStar: "5.0",
    minStar: "0",
    equalsValue: "> 0",
  },
  {
    value: "1",
    label: "1 Star",
    filter: "(GuestTransaction >= 0.1 AND GuestTransaction <= 1.99)",
    maxStar: "1.99",
    minStar: "0.1",
    equalsValue: "= 1",
  },
  {
    value: "2",
    label: "2 Star",
    filter: "(GuestTransaction >= 2.0 AND GuestTransaction <= 2.99)",
    maxStar: "2.99",
    minStar: "2.0",
    equalsValue: "= 2",
  },
  {
    value: "3",
    label: "3 Star",
    filter: "(GuestTransaction >= 3.0 AND GuestTransaction <= 3.99)",
    maxStar: "3.99",
    minStar: "3.0",
    equalsValue: "= 3",
  },
  {
    value: "4",
    label: "4 Star",
    filter: "(GuestTransaction >= 4.0 AND GuestTransaction <= 4.99)",
    maxStar: "4.99",
    minStar: "4",
    equalsValue: "= 4",
  },
  {
    value: "5",
    label: "5 Star",
    filter: "GuestTransaction = 5",
    maxStar: "5",
    minStar: "5",
    equalsValue: "= 5",
  },
];

// constant for four star rating value
export const oneStar = "1";
export const twoStar = "2";
export const threeStar = "3";
export const fourStar = "4";
export const fiveStar = "5";

//Constants for brand Guest Sentiments dropdown
export const starRatingGuestSentimentResponse = [
  {
    value: "",
    label: "Guest Sentiment",
  },
  {
    value: "1",
    label: "1 Star",
  },
  {
    value: "2",
    label: "2 Star",
  },
  {
    value: "3",
    label: "3 Star",
  },
  {
    value: "4",
    label: "4 Star",
  },
  {
    value: "5",
    label: "5 Star",
  },
];

//Constant for to and from date
export const dateFormat = "MM/DD/YYYY";

//Constant for store page route
export const restaurantRoute = "/stores";

export const individualProfileConstant = {
  DASH: "-",
};

export const buttonGroupConstant = {
  GROUP: "group",
  MANAGER: "manager",
  STORE: "store",
};

export const direction = {
  VERTICAL: "vertical",
};

export const monthsInNumbers = {
  oneMonth: 1,
};

export const participationList = [
  {
    value: "",
    label: "All",
    minValue: "0",
    maxValue: "100.0",
  },
  {
    value: "25",
    label: "0% - 25%",
    minValue: "0",
    maxValue: "25",
  },
  {
    value: "50",
    label: "26% - 50%",
    minValue: "26",
    maxValue: "50",
  },
  {
    value: "75",
    label: "51% - 75%",
    minValue: "51",
    maxValue: "75",
  },
  {
    value: "100",
    label: "76% - 100%",
    minValue: "76",
    maxValue: "100",
  },
];

export const newParticipationList = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Greater than",
    value: ">",
  },
  {
    label: "Greater than or equal to",
    value: ">=",
  },
  {
    label: "Less than",
    value: "<",
  },
  {
    label: "Less than or equal to",
    value: "<=",
  },
  {
    label: "Between",
    value: "between",
  },
  {
    label: "Not between",
    value: "notBetween",
  },
  {
    label: "Equal to",
    value: "=",
  },
  {
    label: "Not equal to",
    value: "!=",
  },
];

export const participationListLabels = {
  ALL: "All",
  GREATER_THAN: "Greater than",
  GREATER_THAN_OR_EQUAL_TO: "Greater than or equal to",
  LESS_THAN: "Less than",
  LESS_THAN_OR_EQUAL_TO: "Less than or equal to",
  BETWEEN: "Between",
  NOT_BETWEEN: "Not between",
  EQUAL_TO: "Equal to",
  NOT_EQUAL_TO: "Not equal to",
};
